// Google Ads / UTM attribution + conversion firing for the caregiver web app.
// The marketing site forwards the click ids (gclid/gbraid/wbraid/gad_source) and
// utm_* in the query string; we capture them on arrival, hold them in
// sessionStorage (so they survive in-app navigation), send them with signup, and
// fire the B2C Pilot Signup conversion exactly once per account.

const KEYS = [
  "gclid", "gbraid", "wbraid", "gad_source",
  "utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content",
];
const STORE = "kb_attribution";
const FIRED = "kb_signup_conv_fired";
const CONVERSION_SEND_TO = "AW-18417092508/A-IYCPjN0_IcEJyP-s1E";

// Read attribution params from the current URL into sessionStorage. No-op when
// the URL carries none (so later in-app navigations never clobber the values).
export function captureAttribution() {
  try {
    const params = new URLSearchParams(window.location.search);
    const found = {};
    for (const k of KEYS) {
      const v = params.get(k);
      if (v) found[k] = v.slice(0, 512);
    }
    if (Object.keys(found).length === 0) return;
    const existing = getAttribution();
    const merged = {
      ...existing,
      ...found,
      landing_url: existing.landing_url || window.location.href.slice(0, 2048),
      first_seen_at: existing.first_seen_at || new Date().toISOString(),
    };
    sessionStorage.setItem(STORE, JSON.stringify(merged));
  } catch { /* sessionStorage unavailable — attribution is best-effort */ }
}

export function getAttribution() {
  try { return JSON.parse(sessionStorage.getItem(STORE) || "{}"); }
  catch { return {}; }
}

// ad_consent is a JSON boolean on apex and is TYPE-CHECKED — a wrong value 422s
// the whole signup. Read our shared kb_ad_consent cookie ("1"/"0"); when absent
// (or any other value) return undefined so the field is OMITTED. Never guess
// false: apex drops false rows from the export permanently (CPRA), whereas an
// omitted/unknown consent is still exportable.
function readCookie(name) {
  try {
    const m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
    return m ? decodeURIComponent(m[1]) : null;
  } catch { return null; }
}

export function getAdConsent() {
  const c = readCookie("kb_ad_consent");
  if (c === "1") return true;
  if (c === "0") return false;
  return undefined; // omit — do NOT coerce unknown to false
}

// Fire the B2C Pilot Signup conversion once per account. Guarded so refreshes,
// back-nav or a resumed onboarding can never double-count.
export function trackSignupConversion() {
  try {
    if (sessionStorage.getItem(FIRED)) return;
    if (typeof window.gtag === "function") {
      window.gtag("event", "conversion", { send_to: CONVERSION_SEND_TO });
      sessionStorage.setItem(FIRED, "1");
    }
  } catch { /* ignore — never block the signup flow on analytics */ }
}
